import { IImportedGoalMetricState, IDraftGoalMetricState } from "@gtmhub/whiteboards";
import { Stage, Layer } from "konva/lib/Core";
import { Node, KonvaEventObject, NodeConfig } from "konva/types/Node";

export type Metric = IImportedGoalMetricState | IDraftGoalMetricState;
export type Metrics = IImportedGoalMetricState[] | IDraftGoalMetricState[];

export const MOUSE_ENTER = "mouseenter";
export const MOUSE_LEAVE = "mouseleave";

export const DRAG_START = "dragstart";
export const DRAG_ENTER = "dragenter";
export const DRAG_END = "dragend";
export const DRAG_MOVE = "dragmove";

export const findMetric = (id: string, metrics: Metrics): Metric | undefined => {
  id = id.split("metric-row-")[1];

  if (!id) {
    return;
  }

  return metrics.find((metric) => metric.id === id);
};

export const findMetricByCursor = (metrics: Metrics, stage: Stage, layer: Layer): null | Node<NodeConfig> => {
  const pos = stage.getPointerPosition();
  const shape = layer.getIntersection(pos, ".metric-row");

  if (!shape) {
    return null;
  }

  const metric = findMetric(shape.id(), metrics);
  if (!metric) {
    return null;
  }

  const isDummy = isDummyMetric(metric);
  return isDummy ? null : shape;
};

export const isDummyMetric = (...metrics: Metrics): boolean => {
  return metrics.some((m) => m.name === "");
};

export const orderMetrics = (metrics: Metrics, from: number, to: number) => {
  if (to === from) {
    return metrics;
  }

  if (to > metrics.length - 1) {
    return metrics;
  }

  const target = metrics[from];
  const increment = to < from ? -1 : 1;

  for (let i = from; i != to; i += increment) {
    metrics[i] = metrics[i + increment];
  }

  metrics[to] = target;
  return metrics;
};

export const shouldReoderMetrics = (startMetric: Metric, endMetric: Metric): boolean => {
  if (!startMetric || !endMetric) {
    return false;
  }
  if (startMetric === endMetric) {
    return false;
  }

  if (isDummyMetric(startMetric, endMetric)) {
    return false;
  }

  return true;
};

export const getMetricRangeReorder = (metrics: Metrics, startMetric: Metric, endMetric: Metric): { from: number; to: number } => {
  let from, to;

  for (let index = 0; index < metrics.length; index++) {
    const metric = metrics[index];
    if (metric.id === startMetric.id) {
      from = index;
    }
    if (metric.id === endMetric.id) {
      to = index;
    }
  }

  return { from, to };
};

export const fireShapeEnterEvent = (shape: Node<NodeConfig>, dragEnterPosition: number, evt: KonvaEventObject<unknown>) => {
  return shape.fire(
    DRAG_ENTER,
    {
      type: DRAG_ENTER,
      target: shape,
      dragEnterPos: dragEnterPosition,
      evt: evt.evt,
    },
    true
  );
};
